import React, { useState, useEffect } from "react";
import useToggle from "hooks/useToggle";
import Input from "components/input";
import Loader from "components/loader";
import handleFormChange from "helpers/handle-form-change";
import ErrorMessage from "components/error-message";
import { fetchOrderByBumberAndMail, fetchOrderByTrackingCode, fetchOrderById, fetchOrderByAlternateId } from "services/track-order";
import OrderStatus from "./status";
import clsx from "clsx/lite";

const MalomoOrderTracking = ({ data }) => {
	const [formState, setFormState] = useState({ orderNumber: "", email: "", trackingCode: "" });
	const [loading, toggleLoading] = useToggle();
	const [error, toggleError] = useToggle(false);
	const [order, setOrder] = useState(null);

	const { title, backgroundImage, errorMessage } = data || {};

	const handleResponse = (response) => {
		if (!response || response.code === "not_found" || response.status === 500) {
			toggleError();
		} else {
			setOrder(response);
		}
	};

	const trackOrder = async (e) => {
		e.preventDefault();
		toggleLoading();
		if (error) toggleError();
		const { orderNumber, email, trackingCode } = formState;

		if (!trackingCode && (!orderNumber || !email)) return toggleLoading();

		const response = trackingCode
			? await fetchOrderByTrackingCode(trackingCode)
			: await fetchOrderByBumberAndMail(orderNumber, email);

		handleResponse(response);
		toggleLoading();
	};

	const fetchOrderFromParams = async (id, altId) => {
		if (!id && !altId) return;

		toggleLoading();
		const response = id ? await fetchOrderById(id) : await fetchOrderByAlternateId(altId);
		handleResponse(response);
		toggleLoading();
	};

	// Fetch order from URL parameters
	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const id = params.get("_m_id");
		const altId = params.get("_m_alt_id");

		fetchOrderFromParams(id, altId);
	}, []);

	return (
		<div style={{ backgroundImage: `url(${backgroundImage})` }} className="bg-cover min-h-160">
			<div className="py-10 w-11/12 md:w-1/2 lg:ml-40 mx-auto">
				{title && <h3 className={clsx("mb-2", backgroundImage ? "text-white" : "text-black")}>{title}</h3>}
				<div className="my-8 bg-[#F3F3F3] p-5 max-w-[500px]">
					{order ? <OrderStatus order={order} /> :
						<form
							className="flex flex-col gap-5" onSubmit={trackOrder}
							onChange={(e) => handleFormChange(e, setFormState)}>
							{error && <ErrorMessage message={errorMessage || "We couldn't find your order."} />}
							<Input placeholder="12345" label="Order Number" name="orderNumber" />
							<Input placeholder="abc@gmail.com" label="Email" type="email" name="email" />
							<p className="text-center">or</p>
							<Input placeholder="1234567890" label="Tracking Number" name="trackingCode" />
							<button disabled={loading} className="btn-primary w-full py-4">
								{loading ? <Loader className="size-5" /> : "Track Order"}
							</button>
						</form>}
					<p className="text-center text-black mt-8">
						Need help with tracking your order? Reach out to
						<a href="mailto:info@mod-lighting.com" className="font-bold mx-1 underline">info@mod-lighting.com</a>
						for any questions!
					</p>
				</div>
			</div>
		</div>
	);
};

export default MalomoOrderTracking;